export default "__VITE_PUBLIC_ASSET__301653cc__"